import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { useUserProfile } from '@backstage/plugin-user-settings';

export function useDataDogRum() {
  const { profile } = useUserProfile();
  const config = useApi(configApiRef);
  const datadogEnv = config.getOptionalString('app.datadogEnv');

  // Initialise RUM SDK once per page load, then update user identity when it changes.
  // Skip when env is unset, empty, 'unknown', or 'local' to avoid sending noise.
  useEffect(() => {
    if (!datadogEnv || datadogEnv === 'unknown' || datadogEnv === 'local')
      return;
    if (!datadogRum.getInitConfiguration()) {
      datadogRum.init({
        clientToken: 'pub3743e17ec10b31b6bd274bae82b604ce',
        applicationId: 'd2a1c6c9-048e-4071-a0e9-fdc19e71136d',
        site: 'datadoghq.com',
        service: 'backstage',
        env: datadogEnv,
        sampleRate: 100,
        sessionReplaySampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackInteractions: true,
      });
    }
    datadogRum.setUser({
      id: profile.email,
      name: profile.displayName,
      email: profile.email,
    });
  }, [profile.email, profile.displayName, datadogEnv]);
}
